import type { SVGProps } from 'react';
const SvgCreditCard1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Credit Card 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M16.518 2.643H1.982c-.73 0-1.321.623-1.321 1.39v10.433c0 .768.591 1.391 1.321 1.391h14.536c.73 0 1.321-.623 1.321-1.39V4.033c0-.768-.591-1.391-1.321-1.391M.66 7.268h17.18M12.554 11.893h1.982" />
    </g>
  </svg>
);
export default SvgCreditCard1;
